/**
 * Stable per-browser session identifier used to count distinct anonymous
 * askers when clustering search queries. Persists in localStorage so the
 * same browser is treated as one session across tabs and reloads, but
 * different browsers / incognito windows count separately.
 *
 * This is NOT a security identifier — it is only used for de-duplicating
 * "how many distinct people asked this question" signals.
 */
const STORAGE_KEY = "atp_session_id";

function generate(): string {
  // Prefer crypto.randomUUID where available; fall back to a quick polyfill.
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return "sess-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function getSessionId(): string {
  if (typeof window === "undefined") return "ssr";
  try {
    let id = window.localStorage.getItem(STORAGE_KEY);
    if (!id) {
      id = generate();
      window.localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  } catch {
    // localStorage blocked (private mode, etc.) — fall back to a per-page id.
    return "vol-" + generate();
  }
}
